import { Squares2X2Icon } from "@heroicons/react/24/outline";
import {
    ActivityCategory,
    activityCategoryLabels,
    activityTargetFromView,
    ActivityTargetView,
    isAnySelected,
    serializeActivityTargetView,
} from "@sp-crm/core";
import React from "react";
import { activityCategoryIcons } from "./activity-category-icons";

export const anyActivityLabel = "Any activity";

export const activityTargetSeparator = "or";

const separatorClasses =
    "flex-shrink-0 text-[10px] font-semibold uppercase tracking-wide text-gray-400";

const chipClasses =
    "inline-flex max-w-full items-center gap-1 rounded bg-gray-100 px-1.5 py-0.5 " +
    "text-xs font-medium text-gray-600";

const chipIconClasses = "h-3 w-3 flex-shrink-0";

export const PlainChip: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <span className={chipClasses}>
        <span className="truncate">{children}</span>
    </span>
);

export const ActivityCategoryIcon: React.FC<{
    category: ActivityCategory;
    className: string;
}> = ({ category, className }) => {
    const Icon = activityCategoryIcons[category];
    return <Icon aria-label={activityCategoryLabels[category]} className={className} />;
};

export const ActivityChip: React.FC<{
    category: ActivityCategory;
    label: string;
}> = ({ category, label }) => (
    <span className={chipClasses}>
        <ActivityCategoryIcon category={category} className={chipIconClasses} />
        <span className="truncate">{label}</span>
    </span>
);

export const AnyActivityChip: React.FC<unknown> = () => (
    <span className={chipClasses}>
        <Squares2X2Icon className={chipIconClasses} aria-hidden="true" />
        <span className="truncate">{anyActivityLabel}</span>
    </span>
);

export const ActivityTargetChips: React.FC<{ targets: ActivityTargetView[] }> = ({
    targets,
}) => {
    if (isAnySelected(targets.map(activityTargetFromView))) {
        return <AnyActivityChip />;
    }
    return (
        <span className="inline-flex flex-wrap items-center gap-x-1.5 gap-y-1">
            {targets.map((target, index) => (
                <React.Fragment key={serializeActivityTargetView(target)}>
                    {index === 0 ? null : (
                        <span className={separatorClasses}>
                            {activityTargetSeparator}
                        </span>
                    )}
                    <ActivityChip category={target.category} label={target.label} />
                </React.Fragment>
            ))}
        </span>
    );
};
